import { Pill } from '@ics-portal/guardian';
import { type ReactNode } from 'react';
import { ComponentCreateRequestStatusCode } from '@gql/graphql';
import { StatusIcon } from '@pages/notification-components/components/StatusIcon/StatusIcon';
import { type ComponentCreateRequestMapped } from '@pages/notification-components/models/ComponentCreateRequestMapped';

const StatusCodeOrder = [
    ComponentCreateRequestStatusCode.Approved,
    ComponentCreateRequestStatusCode.Forwarded,
    ComponentCreateRequestStatusCode.Replaced,
    ComponentCreateRequestStatusCode.Removed,
];

type CountedStatuses = Record<string, number>;

interface PillsSummaryProps {
    requests: ComponentCreateRequestMapped[];
}

export function PillsSummary({ requests }: PillsSummaryProps): ReactNode {
    const statuses = Object.values(ComponentCreateRequestStatusCode).sort(
        (a, b) => StatusCodeOrder.indexOf(a) - StatusCodeOrder.indexOf(b),
    );
    const countedStatuses: CountedStatuses = requests.reduce<CountedStatuses>(
        (acc, request) => {
            const status = request.statusCode;
            acc[status] = (acc[status] || 0) + 1;
            return acc;
        },
        {},
    );

    return (
        <div className="flex gap-3 flex-wrap">
            {statuses.map((status) => {
                const id = `pill-${status}`;

                return (
                    <Pill key={id} id={id}>
                        <div className="flex align-items-center gap-2">
                            <StatusIcon
                                id={id}
                                status={status}
                                customTooltipPosition
                            />
                            <h3>{countedStatuses[status] || 0}</h3>
                        </div>
                    </Pill>
                );
            })}
        </div>
    );
}
